const NS = 'SiteHeaderSearchBarWidget';
const CLS = 'siteHeaderSearchBarWidget';

export class SiteHeaderSearchBarWidget {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.$siteHeaderWidget = $('[data-wg="SiteHeaderWidget"]');

		this.$element.on('siteHeaderSearchBarWidget.open', () => {
			this.$element.attr('data-active', true);
			this.setPosition();
		});

		this.$element.on('siteHeaderSearchBarWidget.close', () => {
			this.$element.attr('data-active', false);
		});
	}

	setPosition() {
		this.$element.css({
			top: this.$siteHeaderWidget.offset().top + this.$siteHeaderWidget.height()
		});
	}
}

